
    import './styles.scoped.css';
    export default {
  "column-layout": "awsui_column-layout_vj6p7_g358p_17",
  "grid": "awsui_grid_vj6p7_g358p_49",
  "grid-no-gutters": "awsui_grid-no-gutters_vj6p7_g358p_55",
  "grid-variant-text-grid": "awsui_grid-variant-text-grid_vj6p7_g358p_59",
  "grid-breakpoint-default": "awsui_grid-breakpoint-default_vj6p7_g358p_67",
  "grid-columns-1": "awsui_grid-columns-1_vj6p7_g358p_70",
  "grid-breakpoint-xxs": "awsui_grid-breakpoint-xxs_vj6p7_g358p_70",
  "grid-breakpoint-xs": "awsui_grid-breakpoint-xs_vj6p7_g358p_73",
  "grid-columns-2": "awsui_grid-columns-2_vj6p7_g358p_76",
  "grid-columns-3": "awsui_grid-columns-3_vj6p7_g358p_82",
  "grid-columns-4": "awsui_grid-columns-4_vj6p7_g358p_88",
  "grid-vertical-borders": "awsui_grid-vertical-borders_vj6p7_g358p_104",
  "grid-horizontal-borders": "awsui_grid-horizontal-borders_vj6p7_g358p_137",
  "root": "awsui_root_vj6p7_g358p_187",
  "tile-container": "awsui_tile-container_vj6p7_g358p_222",
  "refresh": "awsui_refresh_vj6p7_g358p_247",
  "selected": "awsui_selected_vj6p7_g358p_251",
  "disabled": "awsui_disabled_vj6p7_g358p_251",
  "readonly": "awsui_readonly_vj6p7_g358p_251",
  "has-metadata": "awsui_has-metadata_vj6p7_g358p_254",
  "columns": "awsui_columns_vj6p7_g358p_276",
  "column-1": "awsui_column-1_vj6p7_g358p_283",
  "breakpoint-xs": "awsui_breakpoint-xs_vj6p7_g358p_290",
  "breakpoint-xxs": "awsui_breakpoint-xxs_vj6p7_g358p_294",
  "column-2": "awsui_column-2_vj6p7_g358p_298",
  "column-3": "awsui_column-3_vj6p7_g358p_313",
  "column-4": "awsui_column-4_vj6p7_g358p_328",
  "control": "awsui_control_vj6p7_g358p_344",
  "no-image": "awsui_no-image_vj6p7_g358p_348",
  "image": "awsui_image_vj6p7_g358p_352"
};
  